import { render } from "./UpdateUserProfileForm.vue?vue&type=template&id=2ab16136&scoped=true"
import script from "./UpdateUserProfileForm.vue?vue&type=script&lang=js"
export * from "./UpdateUserProfileForm.vue?vue&type=script&lang=js"

import "./UpdateUserProfileForm.vue?vue&type=style&index=0&id=2ab16136&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab16136"]])

export default __exports__